module.exports = __webpack_public_path__ + "img/471..c93d91dc.jpg";